export const styleTypes = {
  TEXT: 'Text',
  LIST: 'List',
  TABLE: 'Table',
}